import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { mockNews } from '../services/dataService';
import { getNewsImage } from '../utils/imageUtils';

/**
 * News Details Page Component
 */
const NewsDetails = () => {
  const { id } = useParams();
  const news = mockNews.find(n => n.id === id);

  if (!news) {
    return (
      <div className="container" style={{ paddingTop: '50px', textAlign: 'center' }}>
        <h2>News article not found</h2>
        <Link to="/news" className="btn btn-primary" style={{ marginTop: '20px' }}>Back to News</Link>
      </div>
    );
  }

  return (
    <div className="container" style={{ paddingTop: '30px' }}>
      <Link to="/news" className="btn btn-secondary" style={{ marginBottom: '20px' }}>
        ← Back to News
      </Link>

      <article className="card">
        <img 
          src={getNewsImage(news.id, news.headline)} 
          alt={news.headline}
          style={{ 
            width: '100%', 
            maxWidth: '800px',
            height: '400px', 
            objectFit: 'cover', 
            borderRadius: '8px', 
            marginBottom: '20px',
            display: 'block',
            margin: '0 auto 20px'
          }}
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
        <h1 style={{ fontSize: '36px', color: 'var(--highlight-color)', marginBottom: '20px' }}>
          {news.headline}
        </h1>

        <div style={{ 
          display: 'flex', 
          gap: '20px', 
          marginBottom: '30px', 
          paddingBottom: '20px',
          borderBottom: '2px solid var(--card-hover)',
          flexWrap: 'wrap'
        }}>
          <div>
            <strong>Source:</strong> {news.source}
          </div>
          <div>
            <strong>Date:</strong> {news.date}
          </div>
        </div>

        <div style={{ 
          marginBottom: '20px',
          padding: '15px',
          background: 'var(--card-hover)',
          borderRadius: '5px',
          fontSize: '18px',
          color: 'var(--text-dark)',
          fontStyle: 'italic'
        }}>
          {news.summary}
        </div>

        <div style={{ 
          color: 'var(--text-dark)', 
          lineHeight: '1.8', 
          fontSize: '18px',
          whiteSpace: 'pre-wrap'
        }}>
          <p style={{ marginBottom: '20px' }}>{news.content}</p>
          <p style={{ marginBottom: '20px' }}>
            In a groundbreaking development, space agencies around the world are making unprecedented strides 
            in space exploration. The latest mission represents a significant milestone in humanity's quest 
            to explore the cosmos.
          </p>
          <p style={{ marginBottom: '20px' }}>
            Scientists and engineers have been working tirelessly to push the boundaries of what's possible. 
            These achievements open new possibilities for future missions and research opportunities in space.
          </p>
          <p>
            As we continue to expand our presence in space, these developments mark important steps forward 
            in our understanding of the universe and our place within it.
          </p>
        </div>
      </article>
    </div>
  );
};

export default NewsDetails;
